import { useEffect, useState } from "react";
export * from "./stencilproxy/components";
const isCustomEvent = (event) => {
    if (!Object.hasOwn(event, "detail"))
        return false;
    const { detail } = event;
    if (!Object.hasOwn(detail, "acceptedCategories"))
        return false;
    return Array.isArray(detail.acceptedCategories);
};
export const useCookieConsent = () => {
    const [acceptedCategories, setAcceptedCategories] = useState([]);
    const acceptedCategoriesListener = (event) => {
        if (isCustomEvent(event)) {
            setAcceptedCategories(event.detail.acceptedCategories);
        }
    };
    useEffect(() => {
        window.addEventListener("cookie_consent_preferences_restored", acceptedCategoriesListener);
        window.addEventListener("cookie_consent_preferences_updated", acceptedCategoriesListener);
        return () => {
            window.removeEventListener("cookie_consent_preferences_restored", acceptedCategoriesListener);
            window.removeEventListener("cookie_consent_preferences_updated", acceptedCategoriesListener);
        };
    }, []);
    return acceptedCategories;
};
export const triggerCookieConsentBanner = (options) => {
    if (options?.showDetails) {
        document.dispatchEvent(new Event("cookie_consent_details_show"));
    }
    else {
        document.dispatchEvent(new Event("cookie_consent_show"));
    }
};
//# sourceMappingURL=index.js.map